<template>
  <div class="h-full grid grid-rows-[auto_1fr_auto] overflow-hidden">
    <ThreadsNav show-back>
      <template #center>
        {{ game?.name }}
      </template>
      <template #right>
        <Share :share-id="game?.id!" share-type="game" />
      </template>
    </ThreadsNav>
    <div :key="game?.uuid" class="overflow-auto px-4">
      <GalGameCardSkeleton v-if="loading" />
      <div v-else>
        <UserAvatar
          :avatar-url="game?.coverMedia?.url"
          aspect="16/9"
          class="row-span-2 w-full object-cover rounded-xl"
          high-quality
        />

        <div class="flex justify-between mt-2.5 mb-4 px-2">
          <div class="text-xl font-bold">
            {{ game?.name }}
          </div>
          <p>{{ game.playedTimes }} {{ $t("game.playTimes") }}</p>
        </div>
        <div class="flex flex-col gap-0.5">
          <p>
            {{ t("game.gameType") }}
            {{ game?.type && t(`game.type.${game?.type}`) }}
          </p>
          <p>
            {{ t("game.version") }}
            {{ game?.latestVersion?.version }}
          </p>

          <div class="flex items-center">
            <span>{{ t("game.author") }}</span>
            <span
              class="text-primary cursor-pointer"
              @click="onClickMate(game?.mate?.uuid)"
            >
              {{ game?.mate?.name }}
            </span>
          </div>

          <div class="flex items-center flex-wrap">
            <span>{{ $t("game.showUpCharacters") }} </span>
            <template v-for="(item, idx) in characterzz" :key="item.id">
              <span
                class="text-primary cursor-pointer"
                @click="onClickMate(item.mate!.uuid)"
              >
                {{ item.name }}
                <span v-if="idx !== characterzz.length - 1">，</span>
              </span>
            </template>
          </div>
        </div>

        <p class="text-base mt-4 mb-6 whitespace-pre-line">
          {{ game?.description }}
        </p>
        <VanSwipe
          v-if="game?.mediazz?.length > 0"
          :width="game?.mediazz.length === 1 ? swiperWidth / 0.85 : swiperWidth"
          class="my-swipe aspect-[16/9]"
          indicator-color="white"
        >
          <VanSwipeItem
            v-for="item in game.mediazz"
            :key="item.id"
            class="w-full aspect-[16/9]"
          >
            <BaseImg v-if="item.type === 1" :media="item" class="w-full" />
            <video
              v-else
              :poster="item.videoCoverUrl"
              :src="item.url"
              class="w-full"
              controls
              crossorigin="anonymous"
            />
          </VanSwipeItem>
        </VanSwipe>
        <ul class="flex justify-evenly my-2 border p-2 rounded">
          <li
            v-for="item in list"
            :key="item"
            class="flex flex-col items-center"
          >
            <h3 class="font-bold">
              {{
                item === "character"
                  ? game.characterCount! - 1
                  : game[(item + "Count") as keyof typeof game]
              }}
            </h3>
            <div class="flex items-center gap-1">
              <i :class="['iconfont  text-sm', 'icon-' + item]"></i>
              {{ $t(`game.static.${item}`) }}
            </div>
          </li>
        </ul>
        <div v-if="game.collectionzz && game.collectionzz.length > 0">
          <div class="flex justify-between items-center py-1">
            <div class="flex items-center gap-2">
              <i class="iconfont icon-collection text-primary" />
              <div class="flex flex-wrap gap-1">
                <span
                  v-for="(c, idx) in game.collectionzz"
                  :key="c.id"
                  class="text-primary cursor-pointer"
                  @click="
                    router.push({
                      name: 'collectionMain',
                      params: { uuid: c.uuid },
                    })
                  "
                >
                  {{ c.title }}
                  <span v-if="idx < game.collectionzz.length - 1">, </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <rank-status-of-entity
          :item="game"
          :type="CoinBalanceRecordEntityType.Game"
          class="my-2"
        /> -->
      </div>

      <VanTabs v-model:active="activeTab" class="mb-5">
        <VanTab :title="$t('game.characterIntro')" />
        <VanTab
          v-if="game.dtPublish"
          :title="`${$t('Overview.feedback')}(${
            (game?.reply?.replyCount || 0) +
            (game?.reply?.emojiVotezz.length || 0)
          })`"
        />
        <VanTab v-if="game.dtPublish" :title="$t('game.updateLog.title')" />
      </VanTabs>

      <div v-if="activeTab === 0" class="flex flex-col gap-3 pb-4">
        <CharacterGalGameDetailSkeleton v-if="loading" />
        <template v-else>
          <CharacterGalGameDetail
            v-for="item in roleList"
            :key="item.id"
            :character="item"
          />
        </template>
      </div>
      <div v-show="activeTab === 2">
        <ul>
          <li v-for="version in game?.versionzz" :key="version.id">
            <h3 class="text-base font-bold my-2.5">v{{ version.version }}</h3>
            <p class="whitespace-pre-wrap">{{ version.description }}</p>
          </li>
        </ul>
      </div>
      <div v-show="activeTab === 1 && game?.replyId">
        <div class="flex flex-col gap-2 pb-5 border-b mb-2">
          <reaction-mate :reply="reply" />
          <div class="flex w-full justify-between items-end">
            <div class="flex gap-2 flex-wrap">
              <div class="flex gap-1">
                <!-- <Donate v-if="game" :item="game" type="Game" />
                <coin-vote
                  v-if="game"
                  :item="game"
                  :type="CoinBalanceRecordEntityType.Game"
                /> -->
                <button class="btn btn-sm rounded" @click="showEmoji++">
                  <i class="iconify mingcute--thumb-up-line"></i>
                </button>
                <!-- @vue-ignore -->
                <button
                  class="btn btn-sm rounded"
                  @click="()=>onReplyBtnClick({ ...game.reply!, mate: game.mate })"
                >
                  {{ $t("Overview.comments") }}
                  <span v-if="reply && reply.replyCount > 0">
                    ({{ reply?.replyCount }})
                  </span>
                </button>
              </div>
              <reaction-counter :reply="reply" />
            </div>
          </div>
        </div>
        <div>
          {{ game?.reply?.replyCount || 0 }}
          {{ $t("Overview.comments") }}
        </div>
        <reply-list
          :root-id="game?.replyId"
          @on-reply-click="onReplyBtnClick"
          @on-reaction-click="onReplyActionClick"
        />
      </div>
    </div>

    <div
      v-if="activeTab !== 1"
      class="flex justify-center gap-3 px-3 py-2 bg-base-200"
    >
      <button class="btn btn-primary flex-1" @click="startGame">
        {{ $t("Buttons.startGame") }}
      </button>
      <button class="btn flex-1" @click="clickCopy">
        {{ $t("Buttons.copyPlayLink") }}
      </button>
    </div>

    <!-- 底部输入框 -->
    <reply-input
      v-if="activeTab === 1"
      ref="replyInputRef"
      :reply-target="replyTarget"
      :entity="game"
      :entity-type="ReplyEntityType.GalGame"
    />
    <!-- @vue-ignore -->
    <moment-actions
      v-model:show="showActions"
      :moment="toOperateMoment"
      :reply="toOperateReply"
      :showEmoji="showEmoji"
    />
  </div>
</template>

<script lang="ts" setup>
import { useGalGameHome } from "@/stores/galGameHome";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { GAL_GAME_URL_PREFIX } from "@/stores/galGameEditor";
import { copyToClipboard } from "@/modules/common";
import { showSuccessToast } from "vant";
import { useMate } from "@/stores/mate";
import { Moment, Reply } from "@/types/entity";
import GalGameCardSkeleton from "@/components/mobile/gal-game/home/components/GalGameCardSkeleton.vue";
import CharacterGalGameDetailSkeleton from "@/components/mobile/gal-game/home/components/CharacterGalGameDetailSkeleton.vue";
import { ReplyEntityType } from "@/enums";
import { ReplyInputInstance } from "../../reply/ReplyInput.vue";

const { t } = useI18n();
const store = useGalGameHome();
const route = useRoute();
const router = useRouter();
// const game = ref<GalGame>();
const reply = computed<Reply>(() => {
  return store.activeGame?.reply as any;
});

const game = computed(() => store.activeGame);

const swiperWidth = Math.min(window.innerWidth, 576) * 0.85;

const characterzz = computed(() =>
  store.activeGame?.characterzz?.filter(
    (item) => item.role === 1 || item.role === 2
  )
);

type Static = "end" | "character" | "image" | "audio" | "word";

const list: Static[] = ["end", "character", "image", "audio", "word"];

const roleList = ref<GalGameCharacter[]>([]);
const loading = ref(false);

// const character = ref<GalGameCharacter>({});
// const subCharacters = ref<GalGameCharacter[]>([]);

// const player = ref<GalGameCharacter>({});
const activeTab = ref(0);

onMounted(async () => {
  const uuid = route.params.uuid as string;
  loading.value = true;
  try {
    store.activeGameUUID = uuid;
    await store.getOrFetchGame(uuid);
    let main: GalGameCharacter | undefined,
      sub: GalGameCharacter[] = [],
      player: GalGameCharacter | undefined;
    const { reply, mate, characterzz } = store.activeGame;
    for (const {
      id,
      role,
      name,
      introduction,
      avatarMedia,
      mate,
    } of characterzz) {
      if (role === 1)
        main = { id, name, introduction, avatarMedia, mate, role };
      if (role === 2)
        sub.push({ id, name, introduction, avatarMedia, mate, role });
      if (role === 3) player = { id, name, introduction, avatarMedia, role };
    }

    if (main) roleList.value.push(main);
    if (sub.length) roleList.value.push(...sub);
    if (player) roleList.value.push(player);

    replyTarget.value = {
      ...reply,
      //@ts-ignore
      mate,
    };
    // @ts-ignore
    toOperateMoment.value = { reply };
  } finally {
    loading.value = false;
  }
});

onUnmounted(() => {
  store.activeGameUUID = "";
});

const startGame = async () => {
  window.open(`${GAL_GAME_URL_PREFIX}?uuid=${store.activeGameUUID}`);
};

const clickCopy = async () => {
  copyToClipboard(`${GAL_GAME_URL_PREFIX}?uuid=${store.activeGameUUID}`);
  showSuccessToast({ message: t("Message.copySuccessful") });
};

const onClickMate = (mateUuid: any) => {
  router.push({ name: "mateHome", params: { uuid: mateUuid } });
};

// 回复相关
const replyTarget = ref<Reply | null>(null); // 底部输入框的回复目标
const replyInputRef = ref<ReplyInputInstance | null>(null);
const mate = useMate();

// Action Popup
const showActions = ref(false);
const showEmoji = ref(0);
const toOperateMoment = ref<Moment | null>(null);
const toOperateReply = ref<Reply | null>(null);

const onReplyBtnClick = (replay: Reply) => {
  replyTarget.value = replay;
  replyInputRef.value?.focus();
};
const onReplyActionClick = (reply: Reply) => {
  toOperateReply.value = reply;
  showActions.value = true;
};
</script>
